/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/react';

const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
    opacity: 1;
  }
  50% {
    background-position: 100% 50%;
    opacity: 0.35;
  }
  100% {
    background-position: 0% 50%;
    opacity: 1;
  }
`;

const styles = {
  animatedBackground: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      var(--cds-color-lighten-0) 0%,
      var(--cds-color-emphasis-primary-background-default) 30%,
      /* Design-specified cyan */ #0ff0ff 70%,
      var(--cds-color-lighten-0) 100%
    );
    background-size: 200% 100%;
    filter: blur(2px);
    mask-image: linear-gradient(to bottom, var(--cds-color-darken-975) 0%, transparent 100%),
      radial-gradient(ellipse 80% 100% at 25% 0%, var(--cds-color-darken-975) 0%, transparent 100%),
      radial-gradient(ellipse 80% 100% at 75% 0%, var(--cds-color-darken-975) 0%, transparent 100%);
    mask-composite: intersect;
    -webkit-mask-image: linear-gradient(to bottom, var(--cds-color-darken-975) 0%, transparent 100%),
      radial-gradient(ellipse 80% 100% at 25% 0%, var(--cds-color-darken-975) 0%, transparent 100%),
      radial-gradient(ellipse 80% 100% at 75% 0%, var(--cds-color-darken-975) 0%, transparent 100%);
    -webkit-mask-composite: source-in;
    animation: ${gradientShift} 10s ease-in-out infinite;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      background-position: 0% 50%;
    }
  `,
};

const LavaLampGradientBackground = () => {
  return <div css={styles.animatedBackground} aria-hidden="true" />;
};

export default LavaLampGradientBackground;
